define([], function() {
	
	var CreditCard = {
		initComplete : false,
		init : function(state) {
			if(!COSTCO.CreditCard.initComplete){
			COSTCO.CreditCard.initComplete = true;
			COSTCO.CreditCard.validationRules();
			COSTCO.CreditCard.forms.creditCardForm().validate({
				rules : { 
				account: { required:true,isAmex:true,customcc:true,costcoCC:true},
				cc_cvc_validator: { required : true, cvv:true},
				cc_nameoncard: { required : true, checkSpecialchar : true },
				cc_expiry_date: { required : true, checkExpiryDate : true }
				},
				messages: {
					account: {required: messages.ERR_CCNUM_REQ, isAmex: messages._ERR_INVALID_AMEX_SELECTEDCARDTYPE, customcc : messages.ERR_INVALID_CREDITCARD_SHORT, costcoCC: messages.COSTCO_CC_DISABLED},
					cc_cvc_validator: {required: messages.ERR_CHECKOUT_PAYMENT_EMPTY_CARDNUMBE_PIN, cvv :messages.ERR_INVALID_CVV},
					cc_nameoncard: {required: messages.ERR_NAME_REQ, checkSpecialchar: messages.ERR_INVALID_CC_NAME},
					cc_expiry_date: {required: messages.ERR_EXPIRYDATE_REQ, checkExpiryDate: messages.ERR_INVALID_DATE}
				},
				errorPlacement: function (error, element) {
					if (element.attr('id') === 'account_validator') {
						$('#account').addClass('error-credit-card');
						$('#account_validator_err_msg').html(error.html());
						$('#account_validator_err_msg').removeClass('hide');
						if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE){
							if(error.html() != "" & error.html() !=null){
								$('iframe').filter('.gw-proxy-number').addClass('error-credit-card');
								$('#isAutoRenew').prop("checked", false);
							} else {
								$('iframe').filter('.gw-proxy-number').removeClass('error-credit-card');
							}
						}
						$('iframe').filter('.gw-proxy-number').focus();						
					} else if (element.attr('id') === 'cc_cvc_validator') {
						COSTCO.CreditCard.isCybersourceEnabled() ? $('#cc_cvc').addClass('error') : $('#cc_cvc').addClass('error-credit-card');
						$('#cc_cvc_err_msg').html(error.html());
						$('#cc_cvc_err_msg').removeClass('hide');
						if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE){
							if(error.html() != "" & error.html() !=null){
								$('iframe').filter('.gw-proxy-securityCode').addClass('error-credit-card');
							} else {
								$('iframe').filter('.gw-proxy-securityCode').removeClass('error-credit-card');
							}
						}
						if(typeof TokenGateway !== "undefined" && TokenGateway.focusField != "cardNumber") {
							$('iframe').filter('.gw-proxy-securityCode').focus();
						}
					} else {
						error.insertAfter(element);
					}
				},
				success: function(label, element) {
					let $element = $(element);
					if ($element.attr('id') === 'account_validator') {
						label.parent().removeClass('error');
						$('#account').removeClass('error-credit-card');
						if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE){
							$('iframe').filter('.gw-proxy-number').removeClass('error-credit-card');
						}
					    label.html('');
					} else if ($element.attr('id') === 'cc_cvc_validator') {
						label.parent().removeClass('error');
						$('#cc_cvc').removeClass('error-credit-card');
						if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE){
							$('iframe').filter('.gw-proxy-securityCode').removeClass('error-credit-card');
						}
					    label.html('');
					} else {
						label.parent().removeClass('error');
					    label.remove();
					}
				},
			})
		
			$('#account').unbind('input').on('input', COSTCO.CreditCard.accountNumberChangeEvent);
			
			var cardType = COSTCO.CreditCard.forms.creditCardForm().find('input[name=payMethodId]').val();
			
			if(state == 'payment'){
				// do something if needed
			}
			
			$(".a11y-tooltip").popover();
			
			// Only need to run this onload
			var expiryDate = $('#cc_expiry_date').val();
			if (expiryDate != null && expiryDate.trim().length == 6) {
				expiryDate = '0' + expiryDate;
				$('#cc_expiry_date').val(expiryDate);
			}
			
			COSTCO.CreditCard.maskInput();
			if($('#isBDAppVar').val() == 'BD'){
				if($('#ach-block-form').length > 0){
					$('#ach-block-form').validate();
				}
				
				if($('#ar-block-form').length > 0){
					$('#ar-block-form').validate();
				}
				
				if($('#ordPayInsVal').length >0){
					var paymentType=$('#ordPayInsVal').val();
					var submitedPaymentType=$('#submitedPayMethodId').val();
					if (submitedPaymentType.length>0){
						paymentType= ( paymentType != submitedPaymentType ? submitedPaymentType : paymentType);
					}
					if(paymentType == 'Check'){
						if(!COSTCO.util.isExternalCarrierShipmode()){
							COSTCO.wallet.showCheckOnDeliverySection();
						}
					}else if(paymentType == 'ACH'){
						
						if($('#isBDAppVar').val() == 'BD' && COSTCO.util.isNdEnabled()){
							
							COSTCO.wallet.showACHSection();
							
					        if (($('input[name=payMethodId]').val() == 'ACH') && !(COSTCO.CreditCard.isPaymentEditAreaVisible())) {			
					    		$('#radio-ach').prop('checked', true);
					    		$('#save_as_default2').prop('checked', true);
					    	};
							
						}else{
							if(!COSTCO.util.isExternalCarrierShipmode()){
								COSTCO.wallet.showACHSection();
								
						        if (($('input[name=payMethodId]').val() == 'ACH') && !(COSTCO.CreditCard.isPaymentEditAreaVisible())) {			
						    		$('#radio-ach').prop('checked', true);
						    		$('#save_as_default2').prop('checked', true);
						    	};
							}
						}
						
					}else if(paymentType == 'LineOfCredit'){
						if(!COSTCO.util.isExternalCarrierShipmode()) {
							COSTCO.wallet.showAcctReceivableSection();
						}
					}else{
						COSTCO.wallet.showCCSection();
					}
				}
	    	}
			}
		},
		forms : {
			creditCardForm : function() { return $('#CheckoutPaymentForm')},
			achForm : function() { return $('#ach-block-form')},
			arForm : function() { return $('#ar-block-form')},
		},
		cardTypes : {
			VISA : 'VISA',
			AMEX : 'AMEX',
			MASTER_CARD : 'Master Card',
			DISCOVER : 'Discover',
			JCB : 'JCB',
			DINERS_CLUB : 'Discover Diners',
			CUP : 'Union Pay',
			COSTCO_CREDIT_CARD : 'Costco Credit Card',
			DEFAULT_PAYMENT : 'DefaultPayment'
		},
		
		accountNumberChangeEvent : function() {
			
			var ccNumber = $(this).val();
	
		},
		
		updatePaymentType : function(cardNumber, $cardTypeInput){
			
			var cardType = COSTCO.CreditCard.getCardType(cardNumber);
		    if (cardType != '?') {
		    	$cardTypeInput.val(cardType);
		    }
		},
		
		isVisaCard : function(cardNumber) {
			return (/^(4)/).test(cardNumber);
		},
		isMasterCard : function(cardNumber) {
			return (/^(2[2-7]|5[1-5])/).test(cardNumber);
		},
		isCostcoCard : function(cardNumber) {
			return (/^(7111|7003)/).test(cardNumber);
		},
		isDiscoverCard : function(cardNumber) {
			return (/^(6011|65|6499|6555|6556)/).test(cardNumber);
		},
		getCardType : function(a) {
			
			a = a.replace(/\s+/g,"");
			
		    if (/^(34|37)/.test(a) && 15 == a.length)
		        return COSTCO.CreditCard.cardTypes.AMEX;
		    if (/^(2[2-7]|5[1-5])/.test(a) && 16 == a.length)
		        return COSTCO.CreditCard.cardTypes.MASTER_CARD;
		    if (/^(30[0-5]|3095|36[0-9]|3[8-9])/.test(a) && (14 == a.length || 16 == a.length))
		    	 return COSTCO.CreditCard.cardTypes.DINERS_CLUB;
			if (/^(3528|35[3-8]|333[7-9]|334)/.test(a) && (15 == a.length || 16 == a.length))
				return COSTCO.CreditCard.cardTypes.JCB;
		    if (!/^(4)/.test(a) || 13 != a.length && 16 != a.length) {
		        if (/^(6011|65|6499|6555|6556|62)/.test(a) && 16 == a.length)
		            return COSTCO.CreditCard.cardTypes.DISCOVER;
		        if (/^(7111|7003)/.test(a) && 16 == a.length)
		            return COSTCO.CreditCard.cardTypes.COSTCO_CREDIT_CARD;
		        if (/^(\*)/.test(a))
		            return COSTCO.CreditCard.cardTypes.DEFAULT_PAYMENT
		    } else
		        return COSTCO.CreditCard.cardTypes.VISA;
		    return "?"
		},
		validationRules : function() {
			
			$.validator.setDefaults({ignore: ".ignore,.ignoreHide"});
			$.validator.addMethod('costcoCC', function(value, element) {
				value = value.replace(/\s+/g, '');
				//check to see if value is costco cc and is disabled, otherwise return true and do normal customcc check.
				if (COSTCO.CreditCard.isCostcoCard(value)) {
					var costcoCCDisabled = $('#costcoCCDisabled').val() == 'true';
					return !costcoCCDisabled;
				}
				return true;
			});
			$.validator.addMethod("isAmex", function( value, element ) {
				value = value.replace(/\s+/g,"");
				var cardTypeTmp = COSTCO.CreditCard.getCardType(value);
				if(COSTCO.CreditCard.cardTypes.AMEX == cardTypeTmp){
					//Amex not allowed - trigger specific error message
					return false;
				}else{
					return true;
				}
			});
			
			/* Replicated $.validator.methods.creditcard() from jquery-1.10.2 for jquery-3.6.3
			* since this is no longer defined in 3.6.3
			* ALM 47238
	     	*/
			 $.validator.addMethod('creditCard', function(value, element) {
				if (this.optional(element)) {
	                return "dependency-mismatch";
	            }
	            if (/[^0-9 \-]+/.test(value)) {
	                return false;
	            }
	            var n = 0, i = 0, r = false, s, o;
	            value = value.replace(/\D/g, "");
	            if (value.length < 13 || value.length > 19) {
	                return false;
	            }
	            for (s = value.length - 1; s >= 0; s--) {
	                o = value.charAt(s);
	                i = parseInt(o, 10);
	                if (r) {
	                    if ((i *= 2) > 9) {
	                        i -= 9;
	                    }
	                }
	                n += i;
	                r = !r;
	            }
	            return n % 10 === 0;
			});
			$.validator.addMethod("customcc", function( value, element ) {
				
				value = value.replace(/\s+/g,"");
				var cardTypeTmp = COSTCO.CreditCard.getCardType(value);
				if(!costcoStoreFeatures.DISCOVER_DINERSCLUB_JCB_CUP_ENABLED){
					if((COSTCO.util.getLocale() == 'en-US' && $('#isBDAppVar').val() == 'BC') 
							&& (cardTypeTmp==COSTCO.CreditCard.cardTypes.DISCOVER || cardTypeTmp==COSTCO.CreditCard.cardTypes.DINERS_CLUB || cardTypeTmp== COSTCO.CreditCard.cardTypes.JCB || cardTypeTmp== COSTCO.CreditCard.cardTypes.CUP)){
						return false;
					}
				}
				if((COSTCO.util.getLocale() == 'en-CA' || COSTCO.util.getLocale() == 'fr-CA' || $('#isBDAppVar').val() == 'BD') 
						&& (cardTypeTmp==COSTCO.CreditCard.cardTypes.DISCOVER || cardTypeTmp==COSTCO.CreditCard.cardTypes.DINERS_CLUB || cardTypeTmp== COSTCO.CreditCard.cardTypes.JCB)){
					return false;
				}
				if(value.indexOf("*") > 0 && value.length >= 14 && value.length <= 16){
					return true;
				}
				return this.optional(element) || /^7\d{15}$/.test(value) || /^\*{11}\s?\d{4}$/.test(value)|| /^\*{12}\s?\d{4}$/.test(value) || $.validator.methods.creditCard.call($.data(element.form,'validator'), value, element);
			});
			
			$.validator.addMethod("ccTypeCheck", function( value, element ) {
				
				var cc = (value + '').replace(/\s/g, ''); //remove space
				 // remove spaces 
				var cardType;
				if ($('input[name=payMethodId]').val() != null) {
					cardType = $('input[name=payMethodId]').val().split(' ').join('');
				}
				 
				var returnVal = false;
				
				if(this.optional(element)){
					return this.optional(element);
				}
				 
				var cardTypeTmp = COSTCO.CreditCard.getCardType(cc);
				if (cardType == cardTypeTmp || '?' != cardTypeTmp ){
					returnVal = true;
				}
				else if (cc.indexOf('*') != -1){
					//This is just a safety net to catch a * in the payment type to indicate there is 
					//a default payment.  If it is falsely entered the payment gateway will catch and throw an error.
					returnVal = true;
				}
				else {
					returnVal = false;
				}
				
				
				return returnVal; 				
				
			});
			
			$.validator.addMethod("cvv", function( value, element ) {
				return (value.trim().length == 3);
				
			});
			
			$.validator.addMethod("checkSpecialchar", function( value, element ) {
				// CC name shouldn't have any non-alphanumeric characters and needs at least 1 letter				
				return this.optional(element) || (!COSTCO.util.CC_NAME_FIELD_REGEX.test(value) && COSTCO.util.ATLEAST_ONE_ALPHABET.test(value));
			});
			
			$.validator.addMethod("checkExpiryDate", function( value, element ) {
				let success = this.optional(element) || (/^(0[1-9]|1[012])\/([123]\d)$/).test(value);
				if(!success) {
					COSTCO.util.announceSRMessage(messages.ACCOUNT_PAYMENT_METHODS_ERR_INVALID_DATE);
				} 
				return success;
			});
			
			$.validator.addMethod("checkIsDateInPast", function(value, element ) {
				  let enteredMonth = parseInt(value.split('/')[0]);
				  let enteredYear = parseInt(value.split('/')[1]);
				  let now = new Date();
				  let currentMonth = parseInt((now.getMonth() + 1).toString());
				  let currentYear = parseInt(now.getFullYear().toString().substr(-2));
				  if (enteredYear < currentYear || (enteredYear == currentYear && enteredMonth < currentMonth)) {
					  return false;
				  } 
				  else{
					  return true;
				  }
			 });
			
		},
		validate : {
			creditCardForm : function(isCvvCodeValidationIgnored) {
			
				if($('#outstandingPrincipal').length > 0 && $('#outstandingPrincipal').val() == 0 && !COSTCO.OrderSummary.isMembershipPurchaseOptinSelected()){
					return true;
				}

				var form = COSTCO.CreditCard.forms.creditCardForm();
				if ($('input[name=payMethodId]').val()=='Costco Credit Card')  {
					$('#cc_cvc_validator').val("123");
	    			$('#cc_expiry_date').addClass('ignore').val("");
				}else{
					$('#cc_expiry_date').removeClass('ignore');
				}
				
				//since cvv validation is only required if user clicks on change link,
				//we need to add ignore class to skip validation of blank cvv field if
				//the user does not click change.
				if ($('#cc_cvv_div').is(':hidden') || isCvvCodeValidationIgnored) {
					$('#cc_cvc_validator').addClass('ignore');
				} else {
					$('#cc_cvc_validator').removeClass('ignore');
				}
				
				if (form.length != 0) {
					return form.valid();
				}
			
			}
		},
		submit : {
			creditCardForm : function() {
				$('.order-ajax').addClass('ajax-busy');
				var form = COSTCO.CreditCard.forms.creditCardForm();
				var expDate = $(form).find('input[name=cc_expiry_date]').val().split('/');
				$('#creditCardTokenSessionId').val(modularTokenSessionId);
				
				$(form).find('input[name=expire_month]').val(expDate[0]);
				if(typeof expDate[1] != 'undefined' && expDate[1].length == 2){
					
					$(form).find('input[name=expire_year]').val('20' + expDate[1]);
				}
				if($('#checkoutPage').length > 0 && $('#checkoutPage').val() == 'review'){
					if($('[name=walletCheckout]').attr('value') == 'false'){
						$(form).find('input[name=ccLastFour]').val($(form).find('input[name=account]').val().slice(-4));
					}
				}
				if(costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED !== 'undefined'
					&& costcoStoreFeatures.MEMBERSHIP_CHECKOUT_AUTO_RENEW_OPTION_ENABLED && 
					($('input[name="isQuickPurchase"]') !== undefined && $('input[name="isQuickPurchase"]').val() === 'true' 
						|| $('input[name="isQuickPurchaseFlow"]') !== undefined && $('input[name="isQuickPurchaseFlow"]').val() === 'true')){
					
					if($("input[name='radio-auto-renew']:checked").val() !== undefined && $("input[name='radio-auto-renew']:checked").val() == 'optin'){
						digitalDataEvents.push( {ui:"Checkout Flow | Check | Enroll For Membership Auto Renewal" } );
						
					} else {
						digitalDataEvents.push( {ui:"Checkout Flow | Check | Don't Enroll For Membership Auto Renewal"  } );
					}
				}

				// [0] skips jquery validation - validation must be handled in a different method
				form[0].submit();
	
			},
			achForm : function() {
				$('.order-ajax').addClass('ajax-busy');
				var form = COSTCO.CreditCard.forms.achForm();
				form[0].submit();
			},
			arForm : function() {
				$('.order-ajax').addClass('ajax-busy');
				var form = COSTCO.CreditCard.forms.arForm();
				form[0].submit();
			}
		},
		/**
		 * Uses the Jquery Mask plugin to format input fields. Use cleanVal() instead of val() to get unformatted value
		 */
		maskInput: function() {
			$('#cc_expiry_date').mask('00/00', {
				placeholder: 'MM/YY',
			});
			$('#account').mask('ZZZZ ZZZZ ZZZZ 0000', {selectOnFocus: true, translation: {'Z': {pattern: '[\\*0-9]'}}});
			$('#cc_cvc').mask('0009');
		},
		/**
		 * Checks the state of the credit card radio button selection
		 * @return 1 if user has selected credit card radio button, otherwise returns 0
		 */
		isCreditCardOptionSelected : function () {
			return $('input[id=radio-credit-card]:checked').length || (COSTCO.Checkout.displayAllPayments() && $('input[id=radio-credit-card-review]:checked').length);
		},
    showErrorBox: function() {
			$('#credit-card-block').addClass('error-box');
			if($('#isBDAppVar').val() == 'BD'){
				if($("#check-del-block") && $("#check-del-block").length > 0){
					$('#check-del-block').addClass('error-box');
				}
				if($("#ach-block") && $("#ach-block").length > 0){
					$('#ach-block').addClass('error-box');
				}
				if($("#acc-receiv-block") && $("#acc-receiv-block").length > 0){
					$('#acc-receiv-block').addClass('error-box');
				}
			}
    },
    hideErrorBox: function() {
    	$('#credit-card-block').removeClass('error-box');
    	if($('#isBDAppVar').val() == 'BD'){
			if($("#check-del-block") && $("#check-del-block").length > 0){
				$('#check-del-block').removeClass('error-box');
			}
			if($("#ach-block") && $("#ach-block").length > 0){
				$('#ach-block').removeClass('error-box');
			}
			if($("#acc-receiv-block") && $("#acc-receiv-block").length > 0){
				$('#acc-receiv-block').removeClass('error-box');
			}
		}
    },
    isSelected: function() {
    	let selected = $('#credit-card-block input[name=\'payment-radio\']:checked').val();
        return selected;
    },
    isUsed: function() {
    	return ($('#credit-card-info-container').length > 0 && !$('#credit-card-info-container').hasClass('hide'));
    },
    isApplied: function() {
    	return ($('input[id=ordPayInsVal]').length > 0 && $('input[id=ordPayInsVal]').val() == 'CreditCard');
    },
	isPaymentEditAreaVisible: function() {
		let paymentEditAreaVisible = ($('#credit-card-block').length > 0 && ($('#credit-card-block').attr('class') != 'hide'));
        return paymentEditAreaVisible;
	},
	isCCEditAreaVisible: function(){
		let creditCardEditAreaVisible = ($('#credit-card-block').length > 0 && !$('#credit-card-block').hasClass('hide')) && (this.isCreditCardOptionSelected() > 0);
		return creditCardEditAreaVisible;
	},
	isCCEditAreaHidden: function(){
		let creditCardEditAreaHidden = ($('#credit-card-block').length > 0 && $('#credit-card-block').hasClass('hide')) && (this.isCreditCardOptionSelected() > 0);
		return creditCardEditAreaHidden;
	},
	isCybersourceEnabled: function(){
    	return ($("#cybersourceEnabled").val() ==='true');
    },
    is3DSPaymentAuthEnabled: function(){
    	return ($("#threeDSPaymentEnabled").val() ==='true');
    },
    is3DSMemberCheckoutEnabled: function(){
    	return ($("#is3DSMemberCheckoutEnabled").val() ==='true');
    },
	}
	
	if (typeof window.COSTCO === 'undefined') {
		window.COSTCO = new Object();
	}
	window.COSTCO.CreditCard = CreditCard;
	
	return CreditCard;
});


// WEBPACK FOOTER //
// ./js/checkout/creditcard.js